<template>
  <v-row class="ma-0">
    <v-col class="pa-0 ma-0">
      <v-text-field
        class="search-text pt-0"
        autocomplete="off"
        v-on:keyup.enter="searchData"
        v-model="searchText"
        :data-test-id="`${parentDataTestId}__search-bar__input-box`"
      >
        <v-icon
          v-if="!searchText.length"
          slot="append"
          color="#58E2C2"
          :data-test-id="`${parentDataTestId}__search-bar__search-icon`"
        >
          search
        </v-icon>
        <v-icon
          slot="append"
          :color="primaryColor"
          @click.native="cancelSearch"
          v-if="searchText.length"
          :data-test-id="`${parentDataTestId}__search-bar__close-icon`"
        >
          close
        </v-icon>
      </v-text-field>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'AdvanceSearchBar',
  props: {
    primaryColor: String,
    parentDataTestId: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      searchText: ''
    };
  },
  methods: {
    searchData() {
      this.$emit('searchData', this.searchText);
      this.searchText = '';
    },
    cancelSearch() {
      this.searchText = '';
      this.$emit('cancelSearch');
    }
  }
};
</script>
<style scoped>
.v-icon {
  cursor: pointer;
}
</style>
